import Navi from "./navi";
import Branch from "./branches";
import { Container, Row, Col, Accordion, Button } from 'react-bootstrap';
import arrow from '../Images/arrow.png';
import f_mobile from "../Images/cour1.PNG";
import mern from "../Images/cour2.PNG";
import fr_mobile from "../Images/cour3.PNG";
import cour4 from "../Images/cour4.PNG";
import python from '../Images/cour5.jpeg';
import cour6 from '../Images/cour6.jpeg';
import java from '../Images/cour7.jpeg';
import dm from '../Images/digitalmarketing.jpeg';
import ds from '../Images/ds.jpeg';
import ml from '../Images/ml.jpg';
import da from '../Images/da.jpg';

import "bootstrap-icons/font/bootstrap-icons.css";
import { href, useNavigate } from "react-router-dom";
import "../App.css"

function Techie() {
    const navigate = useNavigate();

    return (
        <div className="a11" >
            <p className="a27">Who’s this for?</p>
            <Container>
                <Row>
                    <Col md={4}>
                        <div className="a29">
                            <img src={arrow} className="a28" />
                            <p>Students/Graduates wanting to explore the vast field of marketing</p>
                        </div>
                    </Col>
                    <Col md={4}>
                        <div className="a29">
                            <img src={arrow} className="a28" />
                            <p>Working professionals with 0-2 years of experience aiming</p>
                        </div>
                    </Col>
                    <Col md={4}>
                        <div className="a29">
                            <img src={arrow} className="a28" />
                            <p>Professionals wanting to switch to software career</p>
                        </div>
                    </Col>
                </Row>
                <div className="text-center">
                    <a href='https://wa.me/918667641134?text=Hii..' target='_blank'>
                        <button className="a30">Register Now <i class="bi bi-arrow-up-right"></i></button>
                    </a>
                </div>
            </Container><br /><br />
            <div className="a31" id="courses">
                <br /><br /><br />
                <Container>
                    <h1 className="a32">COURSE WE OFFER:</h1>
                    <p className="a32">Our job-oriented course gives you the comfortability & Support at the right time</p>
                    <br /><br />
                    <Row >
                        {/* <Col md={6} style={{ height: "300px" }}>
                            <div id="one"  >
                                <img src={ds} className="a33" onClick={() => navigate('/info-ds')} />
                                <h4 className="a34">Data Science:</h4>
                                <p className="a32">
                                    Master the art of turning raw data into powerful insights.
                                    Our Data Science course covers Python, statistics, machine learning,
                                    and big data tools to prepare you for solving complex real-world problems.
                                </p>
                                <Row>
                                    <Button>View Details</Button>
                                </Row>
                            </div>
                        </Col> */}


                        {/*Web Full Stack */}
                        <Col md={6} >
                            <div id="one" className="course-card p-3 shadow-sm rounded">
                                <img
                                    src={mern}
                                    className="a33 mb-3 rounded"
                                    onClick={() => navigate('/info-mern')}
                                    style={{ cursor: "pointer", height: "140px", objectFit: "fill", width: "100%" }}
                                />
                                <h4 className="a34 fw-bold mb-2" style={{ cursor: "pointer" }} onClick={() => navigate('/info-mern')}>Web Full-Stack Development:</h4>
                                <p className="a32" style={{ fontSize: "14px" }}>
                                    This course involves a well-rounded skill set and the ability to work
                                    on both the client and server sides of a web application. It's important for developers to stay
                                    updated on the latest technologies.
                                </p>
                                <Row className="mt-3">
                                    <Col className="d-flex justify-content-center">
                                        <Button
                                            className="w-100 fw-semibold shadow-sm custom-btn1"
                                            onClick={() => {
                                                const section = document.getElementById("book");
                                                if (section) {
                                                    section.scrollIntoView({ behavior: "smooth" });
                                                    // also force-update hash so ScrollSpy syncs correctly
                                                    window.history.replaceState(null, null, "#book");
                                                }
                                            }}
                                        >
                                            Book a Demo
                                        </Button>
                                    </Col>

                                    <Col className="d-flex justify-content-center">
                                        <Button
                                            className="w-100 fw-semibold shadow-sm custom-btn"
                                            onClick={() => navigate('/info-mern')}
                                        >
                                            View Details
                                        </Button>
                                    </Col>
                                </Row>

                            </div>
                        </Col>

                        {/* Mobile Full Stack */}
                        <Col md={6} >
                            <div id="one" className="course-card p-3 shadow-sm rounded">
                                <img
                                    src={f_mobile}
                                    className="a33 mb-3 rounded"
                                    onClick={() => navigate('/info-mobile_full_stack')}
                                    style={{ cursor: "pointer", height: "140px", objectFit: "fill", width: "100%" }}
                                />
                                <h4 className="a34 fw-bold mb-2" style={{ cursor: "pointer" }} onClick={() => navigate('/info-mobile_full_stack')}>Mobile Full Stack Development:</h4>
                                <p className="a32" style={{ fontSize: "14px" }}>
                                    This course involves creating applications that run on mobile devices.
                                    Developers working on mobile full-stack development need to have expertise in both front-end,
                                    back-end technologies and platform-specific expertise.
                                </p>
                                <Row className="mt-3">
                                    <Col className="d-flex justify-content-center">
                                        <Button
                                            className="w-100 fw-semibold shadow-sm custom-btn1"
                                            onClick={() => {
                                                const section = document.getElementById("book");
                                                if (section) {
                                                    section.scrollIntoView({ behavior: "smooth" });
                                                    // also force-update hash so ScrollSpy syncs correctly
                                                    window.history.replaceState(null, null, "#book");
                                                }
                                            }}
                                        >
                                            Book a Demo
                                        </Button>
                                    </Col>

                                    <Col className="d-flex justify-content-center">
                                        <Button
                                            className="w-100 fw-semibold shadow-sm custom-btn"
                                            onClick={() => navigate('/info-mobile_full_stack')}
                                        >
                                            View Details
                                        </Button>
                                    </Col>
                                </Row>

                            </div>
                        </Col>

                        {/* Mobile Front End */}
                        <Col md={6} >
                            <div id="one" className="course-card p-3 shadow-sm rounded">
                                <img
                                    src={fr_mobile}
                                    className="a33 mb-3 rounded"
                                    onClick={() => navigate('/info-mobile_front_end')}
                                    style={{ cursor: "pointer", height: "140px", objectFit: "fill", width: "100%" }}
                                />
                                <h4 className="a34 fw-bold mb-2" style={{ cursor: "pointer" }} onClick={() => navigate('/info-mobile_front_end')}>Mobile Front-End Development:</h4>
                                <p className="a32" style={{ fontSize: "14px" }}>
                                    This course has a dynamic field, and staying updated with the latest
                                    technologies and best practices is crucial for creating successful
                                    and engaging mobile applications effectively.
                                </p>
                                <Row className="mt-3">
                                    <Col className="d-flex justify-content-center">
                                        <Button
                                            className="w-100 fw-semibold shadow-sm custom-btn1"
                                            onClick={() => {
                                                const section = document.getElementById("book");
                                                if (section) {
                                                    section.scrollIntoView({ behavior: "smooth" });
                                                    // also force-update hash so ScrollSpy syncs correctly
                                                    window.history.replaceState(null, null, "#book");
                                                }
                                            }}
                                        >
                                            Book a Demo
                                        </Button>
                                    </Col>

                                    <Col className="d-flex justify-content-center">
                                        <Button
                                            className="w-100 fw-semibold shadow-sm custom-btn"
                                            onClick={() => navigate('/info-mobile_front_end')}
                                        >
                                            View Details
                                        </Button>
                                    </Col>
                                </Row>

                            </div>
                        </Col>

                        {/* Python Full Stack*/}
                        <Col md={6} >
                            <div id="one" className="course-card p-3 shadow-sm rounded">
                                <img
                                    src={python}
                                    className="a33 mb-3 rounded"
                                    onClick={() => navigate('/info-python_full_stack')}
                                    style={{ cursor: "pointer", height: "140px", objectFit: "fill", width: "100%" }}
                                />
                                <h4 className="a34 fw-bold mb-2" style={{ cursor: "pointer" }} onClick={() => navigate('/info-python_full_stack')}>Full Stack Python:</h4>
                                <p className="a32" style={{ fontSize: "14px" }}>
                                    A Full Stack Python Developer refers to a software developer who is proficient
                                    in working on both the front-end (client-side)
                                    and back-end (server-side) of web applications using Python Django.

                                </p>
                                <Row className="mt-3">
                                    <Col className="d-flex justify-content-center">
                                        <Button
                                            className="w-100 fw-semibold shadow-sm custom-btn1"
                                            onClick={() => {
                                                const section = document.getElementById("book");
                                                if (section) {
                                                    section.scrollIntoView({ behavior: "smooth" });
                                                    // also force-update hash so ScrollSpy syncs correctly
                                                    window.history.replaceState(null, null, "#book");
                                                }
                                            }}
                                        >
                                            Book a Demo
                                        </Button>
                                    </Col>

                                    <Col className="d-flex justify-content-center">
                                        <Button
                                            className="w-100 fw-semibold shadow-sm custom-btn"
                                            onClick={() => navigate('/info-python_full_stack')}
                                        >
                                            View Details
                                        </Button>
                                    </Col>
                                </Row>

                            </div>
                        </Col>
                        {/* Java Full Stack */}
                        <Col md={6} >
                            <div id="one" className="course-card p-3 shadow-sm rounded">
                                <img
                                    src={java}
                                    className="a33 mb-3 rounded"
                                    onClick={() => navigate('/info-java_full_stack')}
                                    style={{ cursor: "pointer", height: "140px", objectFit: "fill", width: "100%" }}
                                />
                                <h4 className="a34 fw-bold mb-2" style={{ cursor: "pointer" }} onClick={() => navigate('/info-java_full_stack')} >Full Stack Java:</h4>
                                <p className="a32" style={{ fontSize: "14px" }}>
                                    A Full Stack Java Developer refers to a software developer who is proficient in working on both the front-end (client-side)
                                    and back-end (server-side) of web applications using Java technologies.
                                </p>
                                <Row className="mt-3">
                                    <Col className="d-flex justify-content-center">
                                        <Button
                                            className="w-100 fw-semibold shadow-sm custom-btn1"
                                            onClick={() => {
                                                const section = document.getElementById("book");
                                                if (section) {
                                                    section.scrollIntoView({ behavior: "smooth" });
                                                    // also force-update hash so ScrollSpy syncs correctly
                                                    window.history.replaceState(null, null, "#book");
                                                }
                                            }}
                                        >
                                            Book a Demo
                                        </Button>
                                    </Col>

                                    <Col className="d-flex justify-content-center">
                                        <Button
                                            className="w-100 fw-semibold shadow-sm custom-btn"
                                            onClick={() => navigate('/info-java_full_stack')}
                                        >
                                            View Details
                                        </Button>
                                    </Col>
                                </Row>

                            </div>
                        </Col>


                        {/* Data Analytics */}
                        <Col md={6} >
                            <div id="one" className="course-card p-3 shadow-sm rounded">
                                <img
                                    src={da}
                                    className="a33 mb-3 rounded"
                                    onClick={() => navigate('/info-data-analytics')}
                                    style={{ cursor: "pointer", height: "140px", objectFit: "fill", width: "100%" }}
                                />
                                <h4 className="a34 fw-bold mb-2" style={{ cursor: "pointer" }} onClick={() => navigate('/info-data-analytics')}>Data Analytics:</h4>
                                <p className="a32" style={{ fontSize: "14px" }}>
                                    Develop the skills to analyze data and drive business decisions.
                                    You’ll learn Excel, SQL, visualization tools, and business intelligence
                                    methods to uncover trends and actionable insights.
                                </p>
                                <Row className="mt-3">
                                    <Col className="d-flex justify-content-center">
                                        <Button
                                            className="w-100 fw-semibold shadow-sm custom-btn1"
                                            onClick={() => {
                                                const section = document.getElementById("book");
                                                if (section) {
                                                    section.scrollIntoView({ behavior: "smooth" });
                                                    // also force-update hash so ScrollSpy syncs correctly
                                                    window.history.replaceState(null, null, "#book");
                                                }
                                            }}
                                        >
                                            Book a Demo
                                        </Button>
                                    </Col>

                                    <Col className="d-flex justify-content-center">
                                        <Button
                                            className="w-100 fw-semibold shadow-sm custom-btn"
                                            onClick={() => navigate('/info-data-analytics')}
                                        >
                                            View Details
                                        </Button>
                                    </Col>
                                </Row>

                            </div>
                        </Col>

                        {/* Data Science */}
                        <Col md={6} >
                            <div id="one" className="course-card p-3 shadow-sm rounded">
                                <img
                                    src={ds}
                                    className="a33 mb-3 rounded"
                                    onClick={() => navigate('/info-ds')}
                                    style={{ cursor: "pointer", height: "140px", objectFit: "fill", width: "100%" }}
                                />
                                <h4 className="a34 fw-bold mb-2" style={{ cursor: "pointer" }} onClick={() => navigate('/info-ds')}>Data Science:</h4>
                                <p className="a32" style={{ fontSize: "14px" }}>
                                    Master the art of turning raw data into powerful business insights.
                                    Learn Python, statistics, advanced machine learning, and modern big
                                    data tools to solve complex real-world challenges effectively.
                                </p>
                                <Row className="mt-3">
                                    <Col className="d-flex justify-content-center">
                                        <Button
                                            className="w-100 fw-semibold shadow-sm custom-btn1"
                                            onClick={() => {
                                                const section = document.getElementById("book");
                                                if (section) {
                                                    section.scrollIntoView({ behavior: "smooth" });
                                                    // also force-update hash so ScrollSpy syncs correctly
                                                    window.history.replaceState(null, null, "#book");
                                                }
                                            }}
                                        >
                                            Book a Demo
                                        </Button>
                                    </Col>

                                    <Col className="d-flex justify-content-center">
                                        <Button
                                            className="w-100 fw-semibold shadow-sm custom-btn"
                                            onClick={() => navigate('/info-ds')}
                                        >
                                            View Details
                                        </Button>
                                    </Col>
                                </Row>

                            </div>
                        </Col>
                        {/* Machine Learning */}
                        <Col md={6} >
                            <div id="one" className="course-card p-3 shadow-sm rounded">
                                <img
                                    src={ml}
                                    className="a33 mb-3 rounded"
                                    onClick={() => navigate('/info-machine-learning')}
                                    style={{ cursor: "pointer", height: "140px", objectFit: "fill", width: "100%" }}
                                />
                                <h4 className="a34 fw-bold mb-2" style={{ cursor: "pointer" }} onClick={() => navigate('/info-machine-learning')}>Machine Learning:</h4>
                                <p className="a32" style={{ fontSize: "14px" }}>
                                    Learn how machines can learn and adapt without explicit programming.
                                    This course explores supervised and unsupervised learning, deep learning,
                                    and AI models that power today’s smart applications.
                                </p>
                                <Row className="mt-3">
                                    <Col className="d-flex justify-content-center">
                                        <Button
                                            className="w-100 fw-semibold shadow-sm custom-btn1"
                                            onClick={() => {
                                                const section = document.getElementById("book");
                                                if (section) {
                                                    section.scrollIntoView({ behavior: "smooth" });
                                                    // also force-update hash so ScrollSpy syncs correctly
                                                    window.history.replaceState(null, null, "#book");
                                                }
                                            }}
                                        >
                                            Book a Demo
                                        </Button>
                                    </Col>

                                    <Col className="d-flex justify-content-center">
                                        <Button
                                            className="w-100 fw-semibold shadow-sm custom-btn"
                                            onClick={() => navigate('/info-machine-learning')}
                                        >
                                            View Details
                                        </Button>
                                    </Col>
                                </Row>

                            </div>
                        </Col>


                        {/* Digital Marketing */}
                        {/* <Col md={12} >
                            <div id="one1" className="course-card p-3 shadow-sm rounded">

                                <Row >
                                    <Col md={6}><img
                                        src={dm}
                                        className="a33 mb-3 rounded"
                                        onClick={() => navigate('/info-digital-marketing')}
                                        style={{ cursor: "pointer", height: "140px", objectFit: "fill", width: "100%" }}
                                    /></Col>
                                    <Col md={6}>
                                        <h4 className="a34 fw-bold mb-2" style={{ cursor: "pointer" }} onClick={() => navigate('/info-digital-marketing')}>Digital Marketing:</h4>
                                        <p className="a32" style={{ fontSize: "14px" }}>
                                            Digital Marketing is an ever-evolving field, and staying
                                            updated with the latest trends, tools, and strategies is essential for
                                            building impactful campaigns and reaching the right audience effectively.
                                        </p>
                                        <Row className="mt-3">
                                            <Col className="d-flex justify-content-center">
                                                <Button
                                                    className="w-100 fw-semibold shadow-sm custom-btn1"
                                                    onClick={() => {
                                                        const section = document.getElementById("book");
                                                        if (section) {
                                                            section.scrollIntoView({ behavior: "smooth" });
                                                            // also force-update hash so ScrollSpy syncs correctly
                                                            window.history.replaceState(null, null, "#book");
                                                        }
                                                    }}
                                                >
                                                    Book a Demo
                                                </Button>
                                            </Col>

                                            <Col className="d-flex justify-content-center">
                                                <Button
                                                    className="w-100 fw-semibold shadow-sm custom-btn"
                                                    onClick={() => navigate('/info-digital-marketing')}
                                                >
                                                    View Details
                                                </Button>
                                            </Col>
                                        </Row></Col>

                                </Row>
                            </div>
                        </Col> */}
                    </Row>
                </Container>

            </div>

            <Container id="FAQ">
                <br /><br />
                <h1>Frequently Asked Questions</h1>
                <br /><br />
                <Row>
                    <Col md={6}>
                        <Accordion className="a35">
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>What is One on one training?</Accordion.Header>
                                <Accordion.Body>
                                    GT Software college offers personalized attention to the Students such as when
                                    addressing specific skill gaps, mastering complex concepts, or achieving personal goals.
                                    It can be more intensive and focused, leading to more effective and efficient learning
                                    outcomes for the individual.
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                    <Col md={6}>
                        <Accordion className="a35">
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>Duration and timings of the course?</Accordion.Header>
                                <Accordion.Body>
                                    In GT Software College we have Full Day class from 9:30 am to 5:30 pm and the duration of
                                    the course is 3 to 4 months. Duration for Data science and Machine learning courses is 6 months.
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                    <Col md={6}>
                        <Accordion className="a35">
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>Online classes available?</Accordion.Header>
                                <Accordion.Body>
                                    No. Online classes are not encouraged in GT. Strictly we avoid online classes.

                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                    <Col md={6}>
                        <Accordion className="a35">
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>EMI options available?</Accordion.Header>
                                <Accordion.Body>
                                    EMI option is also available in GT Software College
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                    <Col md={6}>
                        <Accordion className="a35">
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>Why is this course 100% in-person and not online?</Accordion.Header>
                                <Accordion.Body>
                                    We think that hands-on programs need face-to-face meetings. Although students can learn on their own time,
                                    all live project meetings are held in person. Project presentations will be helpful in attending interviews.
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                    <Col md={6}>
                        <Accordion className="a35">
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>Do you provide a degree or diploma?</Accordion.Header>
                                <Accordion.Body>
                                    No, we don’t provide degrees or diplomas. We focus on giving you essential programming skills, Problem solving techniques
                                    and job prospects to excel as a developer or potential founder in the startup sector.
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
                <br /><br />
            </Container>
        </div>
    );
}

export default Techie;